import { coreDefaultTheme } from '@kite-js/theme';
import { ULTheme, ULThemeBuilder } from '@theme/types';
import { coreRocketmilesTheme } from '@theme/rocketmiles/theme-rocketmiles';

const RocketmilesThemeBuilder: ULThemeBuilder = (cultureCode?: string, appId?: string) => {
    const theme: ULTheme = {
        ...coreDefaultTheme,
        ...coreRocketmilesTheme,
        logoUrl: "https://cdn6.agoda.net/images/MVC/default/agoda-logo-booking-page@2x.png'",
        background: {
            image: '',
            color: 'rgba(247, 247, 247, 1)',
            position: '0 0',
            size: 'contain',
        },
        faviconUrl: 'https://cdn6.agoda.net/images/mvc/default/favicon/rocketmiles/rocketmiles.ico',
        input: {
            ...coreDefaultTheme.input,
            borderRadius: 'S',
        },
        tab: {
            ...coreDefaultTheme.tab,
            padding: '12px 8px 12px 8px',
        },
    };

    return theme;
};

export default RocketmilesThemeBuilder;
